export default {
  REQUEST: 'REQUEST_GRAPH_QUERY',
  SUCCESS: 'SUCCESS_GRAPH_QUERY',
  FAIL: 'FAIL_GRAPH_QUERY',
  CANCEL: 'CANCEL_GRAPH_QUERY',
  OPEN_MODAL: 'OPEN_GRAPH_QUERY_MODAL',
  CLOSE_MODAL: 'CLOSE_GRAPH_QUERY_MODAL',
  SET_STATUS: 'SET_GRAPH_QUERY_STATUS',
}
